// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import createValidateMethod from '@tcp/core/src/utils/formValidation/createValidateMethod';
import getStandardConfig from '@tcp/core/src/utils/formValidation/validatorStandardConfig';
import PasswordField from '@tcp/core/src/components/features/account/common/molecule/PasswordField/views/PasswordField.view';
import Recaptcha from '@tcp/core/src/components/common/molecules/recaptcha/recaptcha';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import { Field, reduxForm } from 'redux-form';
import { routerPush } from '@tcp/core/src/utils';
import InputCheckbox from '@tcp/core/src/components/common/atoms/InputCheckbox';
import TextBox from '@tcp/core/src/components/common/atoms/TextBox';
import Button from '@tcp/core/src/components/common/atoms/Button';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import RichText from '@tcp/core/src/components/common/atoms/RichText';
import ClickTracker from '@tcp/web/src/components/common/atoms/ClickTracker';
import { getContinueAsGuestPayload } from '@tcp/core/src/constants/analytics';
import { getLabelFromCopyOrFromTranslation } from '@tcp/core/src/utils/labels/labelUtilty';
import LabeledRadioButton from '../../../../../../common/atoms/LabeledRadioButton';
import styles from '../styles/LoginSelectionForm.styles';
import Anchor from '../../../../../../common/atoms/Anchor';
import useLoginSectionForm from '../../../common/LoginSelection/useLoginSectionForm';
import {
  GLOBAL_LOGIN_LABELS,
  GlobalLoginLabels,
} from '../../../../../../../utils/labels/globalLogin.labels';
import {
  GLOBAL_GENERIC_LABELS,
  GlobalGenericLabels,
  lblPassword,
} from '../../../../../../../utils/labels/globalGeneric.labels';
import {
  GLOBAL_ACCESSIBILITY_LABELS,
  GlobalAccessibilityLabels,
  lblPasswordTooltip,
} from '../../../../../../../utils/labels/globalAccessibility.labels';
import {
  GLOBAL_ACTIONS_LABELS,
  GlobalActionsLabels,
  lblLogin,
} from '../../../../../../../utils/labels/globalActions.labels';
import {
  GLOBAL_PASSWORD_LABELS,
  GlobalPasswordsLabels,
} from '../../../../../../../utils/labels/globalPassword.labels';

// eslint-disable-next-line complexity
const LoginSelectionForm = (props) => {
  const {
    tooltipContent,
    change,
    showRecaptcha,
    maskedPhoneNumber,
    isRememberedUser,
    isV2Flow,
    handleContinueAsGuest,
    loginErrorMessage,
    userplccCardNumber,
    userplccCardId,
    className,
    variation,
    isLoading,
    isLoginWithEmailOTPEnabled,
    setRememberUser,
    isCanada,
  } = props;

  const {
    lbl_enter_pwd: lblLoginEnterPwd,
    lbl_login_forgetPasswordCTA: lblLoginForgotPwdCta,
    lbl_login_saveMyPlace: lblLoginSaveMyPlace,
    lbl_login_rememberMe: lblLoginRememberMe,
    lbl_login_rememberMeHelpText: lblLoginRememberMeTxt,
    lbl_login_temp_password: lblLoginTempPwd,
    lbl_code_msg: lblLoginCodeMsg,
    lbl_request_verification_btn: lblRequstVerificationBtn,
    lbl_login_loginAndCheckout: lblLoginAndCheckout,
    lbl_login_checkout_as_guest: lblLoginCheckoutAsGuest,
    lbl_otp_sms_consent: lblSmsOtpContent,
  } = getLabelFromCopyOrFromTranslation(GLOBAL_LOGIN_LABELS, GlobalLoginLabels);

  const {
    lbl_dont_have_phone: lblDontHavePhone,
    lbl_send_code_via_email_instead: lblSendCodeViaEmailInstead,
  } = getLabelFromCopyOrFromTranslation(GLOBAL_PASSWORD_LABELS, GlobalPasswordsLabels);

  const {
    submitForm,
    emailAddress,
    selectedLoginOption,
    setLoginOption,
    showForgotPassword,
    isSMSOpted,
    handleTermsChange,
    sendCodeViaEmail,
    shouldLoginButtonDisabled,
  } = useLoginSectionForm(props, routerPush, lblLoginForgotPwdCta);

  return (
    <div className={`${className} elem-mb-LRG`}>
      <form name="LoginForm" onSubmit={submitForm} noValidate>
        <React.Fragment>
          {loginErrorMessage && (
            <BodyCopy
              fontSize="fs12"
              fontWeight="semibold"
              color="red.500"
              className="elem-ml-XL elem-mb-MED"
            >
              <RichText className="richTextColor" richTextHtml={loginErrorMessage} />
            </BodyCopy>
          )}
          <BodyCopy component="div" className="password-container">
            {/* For browser password manager */}
            <input
              type="text"
              id="hidden_emailAddress"
              aria-hidden="true"
              name="hidden_emailAddress"
              value={emailAddress}
              className="hidden-field"
            />
            <Field
              component={LabeledRadioButton}
              name="password"
              aria-label={'radio_btn'}
              checked={selectedLoginOption === 'password'}
              className="pass-reset-options radio_btn_top"
              title={lblLoginEnterPwd}
              onClick={() => setLoginOption('password')}
              value={selectedLoginOption}
            />
            <Field
              id="password"
              placeholder={getLabelFromCopyOrFromTranslation(
                `${GLOBAL_GENERIC_LABELS}.${lblPassword}`,
                GlobalGenericLabels
              )}
              name="password"
              component={PasswordField}
              dataLocator="login-passwordfield"
              errorDataLocator="login-passworderror"
              showSuccessCheck={false}
              enableSuccessCheck={false}
              className="elem-mt-SM elem-ml-XXL fs14 loginShowTop"
              tooltipContent={tooltipContent}
              tooltipAriaLabel={getLabelFromCopyOrFromTranslation(
                `${GLOBAL_ACCESSIBILITY_LABELS}.${lblPasswordTooltip}`,
                GlobalAccessibilityLabels
              )}
              spc
            />
          </BodyCopy>
          {/* remember me */}
          <div className="elem-mb-MED elem-mt-XS forget-password-wrapper">
            <Anchor
              underline
              fontSizeVariation="large"
              anchorVariation="primary"
              dataLocator="login-forgotpasswordlnk"
              onClick={showForgotPassword}
              id="forgotPasswordForm"
            >
              {lblLoginForgotPwdCta}
            </Anchor>
          </div>
          {userplccCardNumber && userplccCardId && (
            <BodyCopy component="div" className="elem-ml-LRG remember-check">
              <Field
                name="plcc_checkbox"
                component={InputCheckbox}
                dataLocator="login-savemyplcccardcb"
              >
                <BodyCopy fontFamily="secondary" tag="span" fontSize="fs10">
                  {lblLoginSaveMyPlace?.replace('#number', `${userplccCardNumber}`)}
                </BodyCopy>
              </Field>
            </BodyCopy>
          )}
          <BodyCopy component="div" className="elem-ml-LRG remember-check">
            <Field
              name="rememberMe"
              component={InputCheckbox}
              dataLocator="login-remembermecb"
              className={`remember-me-check ${variation === 'checkout' && 'remember-me-checkbox1'}`}
              onChange={setRememberUser}
            >
              <BodyCopy
                fontFamily="secondary"
                tag="span"
                className="remember-me-text"
                fontSize="fs10"
              >
                {lblLoginRememberMe}
              </BodyCopy>
              <BodyCopy
                fontFamily="secondary"
                tag="span"
                fontSize="fs10"
                className="remember-me-sub-text"
              >
                {lblLoginRememberMeTxt}
              </BodyCopy>
            </Field>
          </BodyCopy>
          {/* phone number */}
          {!isCanada && (
            <div className="radio-container elem-mb-XS">
              <BodyCopy component="div">
                <Field
                  component={LabeledRadioButton}
                  name="sms"
                  checked={isSMSOpted}
                  title={lblLoginTempPwd}
                  subtitle={`${lblLoginCodeMsg} ${maskedPhoneNumber}`}
                  className="pass-reset-options elem-mt-XS radio_btn_top"
                  onClick={() => setLoginOption('sms')}
                  value={selectedLoginOption}
                />
                {isSMSOpted && (
                  <BodyCopy component="div" className="sms-terms">
                    <Field
                      name="sms_checkbox"
                      component={InputCheckbox}
                      dataLocator="sms_checkbox-locator"
                      onChange={handleTermsChange}
                    >
                      <BodyCopy fontFamily="secondary" tag="span" fontSize="fs12">
                        {lblSmsOtpContent}
                      </BodyCopy>
                    </Field>
                  </BodyCopy>
                )}
              </BodyCopy>
            </div>
          )}
          {isLoginWithEmailOTPEnabled && (
            <BodyCopy component="div" className="elem-mt-LRG elem-mb-XS">
              {!isCanada && (
                <BodyCopy
                  textAlign="center"
                  fontFamily="secondary"
                  fontWeight="semibold"
                  fontSize="fs14"
                  dataLocator="login-resend-text"
                >
                  {lblDontHavePhone}
                </BodyCopy>
              )}
              <BodyCopy component="div" textAlign="center">
                <Anchor
                  underline
                  anchorVariation="primary"
                  dataLocator="login-resend-email-link"
                  className="resend-email-link"
                  onClick={sendCodeViaEmail}
                >
                  {lblSendCodeViaEmailInstead}
                </Anchor>
              </BodyCopy>
            </BodyCopy>
          )}
          {/* REcapthha */}
          {showRecaptcha && (
            <BodyCopy component="div" className="recaptcha_loginotp elem-mt-MED">
              <Recaptcha
                verifyCallback={(token) => change('recaptchaToken', token)}
                expiredCallback={() => change('recaptchaToken', '')}
              />
              <Field
                id="recaptchaToken"
                component={TextBox}
                type="hidden"
                name="recaptchaToken"
                data-locator="merge-account-confirmation-recaptchca"
              />
            </BodyCopy>
          )}
          {/* button */}
          <BodyCopy component="div" textAlign="center">
            <Button
              fill="BLUE"
              type="submit"
              buttonVariation="fixed-width"
              dataLocator="login-logincta"
              className="elem-mb-MED elem-mt-MED rounded-corner "
              fullWidth
              spc
              loading={isLoading}
              disabled={shouldLoginButtonDisabled()}
            >
              {isSMSOpted && lblRequstVerificationBtn}
              {isV2Flow && !isSMSOpted && lblLoginAndCheckout}
              {!isV2Flow &&
                !isSMSOpted &&
                getLabelFromCopyOrFromTranslation(
                  `${GLOBAL_ACTIONS_LABELS}.${lblLogin}`,
                  GlobalActionsLabels
                )}
            </Button>
            {isV2Flow && !isRememberedUser && (
              <BodyCopy component="div" textAlign="center" className="underline" />
            )}
            {!isRememberedUser && (
              <>
                {(isV2Flow || variation === 'checkout') && (
                  <div className="elem-mb-LRG">
                    <ClickTracker clickData={getContinueAsGuestPayload('checkout-popup')}>
                      <Button
                        fill="WHITE"
                        type="button"
                        buttonVariation="fixed-width"
                        dataLocator="login-logincta"
                        fullWidth
                        onClick={handleContinueAsGuest}
                        className="rounded-corner test-guest-button"
                        spc
                      >
                        {lblLoginCheckoutAsGuest}
                      </Button>
                    </ClickTracker>
                  </div>
                )}
              </>
            )}
          </BodyCopy>
        </React.Fragment>
      </form>
    </div>
  );
};
LoginSelectionForm.propTypes = {
  className: PropTypes.string,
  loginErrorMessage: PropTypes.string,
  showRecaptcha: PropTypes.bool,
  change: PropTypes.func,
  pristine: PropTypes.bool,
  handleContinueAsGuest: PropTypes.func.isRequired,
  userplccCardNumber: PropTypes.string.isRequired,
  userplccCardId: PropTypes.string.isRequired,
  showForgotPasswordForm: PropTypes.bool.isRequired,
  resetForm: PropTypes.bool.isRequired,
  resetLoginState: PropTypes.func,
  isLoading: PropTypes.bool.isRequired,
  tooltipContent: PropTypes.string.isRequired,
  isRememberedUser: PropTypes.bool.isRequired,
  closeModal: PropTypes.func,
  closeOverlay: PropTypes.func,
  fullPage: PropTypes.bool,
  maskedPhoneNumber: PropTypes.string,
  isV2Flow: PropTypes.bool,
  setRememberUser: PropTypes.func,
};
LoginSelectionForm.defaultProps = {
  className: '',
  loginErrorMessage: '',
  showRecaptcha: false,
  change: () => {},
  pristine: false,
  closeModal: () => {},
  closeOverlay: () => {},
  fullPage: false,
  maskedPhoneNumber: '',
  resetLoginState: () => {},
  isV2Flow: '',
  setRememberUser: () => {},
};

const validateMethod = createValidateMethod(
  getStandardConfig([
    { emailAddress: 'emailAddressNoAsync' },
    { password: 'legacyPassword' },
    'recaptchaToken',
  ])
);
export default reduxForm({
  form: 'selectionform', // a unique identifier for this form
  enableReinitialize: true,
  ...validateMethod,
})(withStyles(LoginSelectionForm, styles));

export { LoginSelectionForm as LoginSelectionFormVanilla };
